export default "__VITE_ASSET__BCMm4XF6__"